<template>
  <EditableInputWithIcon
    attribute="name"
    :class="$style.editableInputContainer"
    :config="editableInputConfig"
    :handleSubmit="handleInputSubmit"
    :isEditableFunction="isNameEditable"
    :item="item"
  >
    <span
      :title="getItemName"
    >
      {{ getItemName }}
    </span>
  </EditableInputWithIcon>
</template>

<script>
import {
  DirectoryNameConsts,
  ItemTypeConsts,
  ItemTypeDisplayNames,
  StoreModelMap,
  StoreModuleMap,
} from 'client/util/Constants';
import { extend } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import DirectoryUtil from 'client/util/DirectoryUtil';
import EditableInputWithIcon from 'client/components/ItemTable/BodyComponents/EditableInputWithIcon.vue';

const directoryCollection = StoreModuleMap[ItemTypeConsts.directory];

export default {
  name: 'EditableDirectoryName',

  inject: ['$validator'],

  components: {
    EditableInputWithIcon,
  },

  props: {
    itemType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      duplicateNameError: `A ${DirectoryNameConsts[this.itemType]} directory with this name already exists. Enter a unique name.`,
      editableInputConfig: {
        errorStyleExceptions: this.$style.errorClass,
        inputClass: this.$style.inputClass,
        validate: 'max:255|uniqueNameValidation|required',
      },
    };
  },

  computed: {
    ...mapGetters(directoryCollection, {
      directories: 'getCollection',
    }),

    displayName() {
      return ItemTypeDisplayNames[this.itemType];
    },

    getItemName() {
      return this.isItemBeingCreated ? `New ${this.displayName}` : this.item.name;
    },

    isNameEditable() {
      return () => this.isItemBeingUpdated;
    },
  },

  beforeCreate() {
    const storeModel = StoreModelMap[this.$options.propsData.itemType];

    extend(
      this.$options.computed,
      mapGetters(storeModel, [
        'isItemBeingCreated',
        'isItemBeingUpdated',
        'item',
      ]),
    );

    extend(
      this.$options.methods,
      mapActions(storeModel, [
        'updateItem',
      ]),
    );
  },

  beforeMount() {
    this.$validator.extend('uniqueNameValidation', {
      getMessage: this.duplicateNameError,
      validate: value => !DirectoryUtil.isDuplicateDirectoryName(
        this.directories,
        {
          id: this.item.id,
          name: value.trim(),
          type: this.itemType,
        },
      ),
    });
  },

  methods: {
    handleInputSubmit(item, newValue) {
      const newName = newValue.trim();

      if (item.name === newName) {
        return;
      }

      this.updateItem({ id: item.id, name: newName });
    },
  },
};
</script>

<style module>
.editableInputContainer.editableInputContainer {
  --iconHeight: 35%;
  --iconMaxWidth: 2em;
  --iconLeftOffset: 1em;

  justify-content: center;
  min-height: 5.6rem;
  padding-bottom: 5px;
}

.errorClass {
  font-size: 1.1rem;
  text-align: left;
}

.inputClass.inputClass {
  background: white;
}

</style>
